import React from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { IconLink } from '../IconLink';

export interface Props {
  footerLinksArray: {
    iconName: IconProp,
    link: string,
    trackingTag: string,
    label: string,
    classes?: string,
  }[];
  trackingCallback(event: string, params?: Record<string, unknown>): Promise<void>;
}

export const FixedFooter = ({ footerLinksArray, trackingCallback }: Props): JSX.Element => {
  const handleLinkClicked = async (eventName: string): Promise<void> => {
    const trackingProps = {
      elementText: eventName,
    };

    return trackingCallback('clicked-button', trackingProps);
  };

  return (
    <div role='navigation' className='fixed bottom-0 left-0 text-center md:hidden pt-2 pb-2 bg-white w-full flex flex-wrap justify-center'>
      {footerLinksArray.map(footerLink => (
        <IconLink
          iconName={footerLink.iconName}
          link={footerLink.link}
          label={footerLink.label}
          eventName={footerLink.trackingTag}
          classes={footerLink.classes}
          handleLinkClicked={handleLinkClicked}
          key={footerLink.label}
        />
      ))}
    </div>
  );
};
